import { Collapsible } from './Collapsible';
import { Headline } from '../Typography';

import type { FunctionComponent, PropsWithChildren } from 'react';

type CollapsibleWithHeadlineProps = PropsWithChildren<{
    readonly ariaLabel?: string;
    readonly headline: string;
    readonly isInitiallyExpanded?: boolean;
}>;

export const CollapsibleWithHeadline: FunctionComponent<CollapsibleWithHeadlineProps> = ({
    ariaLabel,
    children,
    headline,
    isInitiallyExpanded,
}) => (
    <Collapsible
        ariaLabel={ariaLabel}
        isInitiallyExpanded={isInitiallyExpanded}
        summary={<Headline variant="h5">{headline}</Headline>}
    >
        {children}
    </Collapsible>
);
